import './style.scss'
import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import ApiContext from 'src/provider/API/call-service'
import { AbsoluteContainer, AppLink, AppSpan, AppText, Button, CustomContainer, FixedContainer, FlexColumn, FlexRow, Form, FormGroup, FormGroupWithIcon, GridContainer } from 'src/style'
//import WhiteLogo from 'src/assets/img/qore-logo-white.svg'
import WhiteLogo from 'src/assets/img/Qstore-logo-white.png'
import {ReactComponent as Logo} from 'src/assets/img/qore-logo.svg'
import LoginImg from 'src/assets/svg/login'
import ServiceIcon from 'src/assets/svg/service-icon'
import { FiChevronDown } from 'react-icons/fi'
import { Dropdown } from 'src/component'
import utility from 'src/utils/utility'
import { UserType } from 'src/model'


// FOR IN-APP SIGNIN
export const SigninV1: React.FC = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {setInfoProperty} = useContext(AppInfoContext)
    const [input, setInput] = useState<any>({institutionCode: '', username: '', password: '', userType: UserType.ADMIN})

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        const response = input.userType === UserType.ADMIN ? 
            await API.loginAsAdmin(input)
            : await API.institutionLoginWithToken({...input, token: 'this is for testing'})

        if (response) {
            if (!response.userDetails) {
                setInfoProperty('userData', {
                    firstName: 'John',
                    lastName: 'Doe', 
                    email: 'ridwan@appzonegroup.com', 
                    userId: '786925QR', 
                    userName: 'Rhydhur',
                    phoneNumber: '07056281920',
                    status: 'Active',
                    institution: {
                        institutionCode: '100010',
                        code: '100010'
                    }
                })
            }

            const routes = {
                [`${UserType.ADMIN}`]: '/admin/dashboard',
                [`${UserType.CLIENT}`]: '/client/discover',
                [`${UserType.PARTNER}`]: '/partner/products'
            }
    
            navigate(routes[input.userType])
        }
    }
    
    return (
        <>
            <CustomContainer 
                width='100' sizeUnit='%' 
                height='100' hUnit='%'
            >
                <FlexRow
                    alignItems='stretch' 
                    justifyContent='flex-start' 
                    height='100' hUnit='%'
                >
                    <FlexColumn 
                        width='50' sizeUnit='%' 
                        minHeight='100' mnHUnit='%'
                        padding='2' bgColor='#101828'
                        className='login-bg-container'
                    >
                        <FlexColumn 
                            justifyContent='space-between'
                            width='50' height='100' hUnit='%'
                            className='login-bg-content'
                        >
                            <GridContainer alignItems='flex-start'>
                                <CustomContainer 
                                    height='3.75' width='14.1' overflow='auto'
                                    bottomMargin='1.5' topMargin='6'
                                >
                                    <img src={WhiteLogo} className='img-covered'/>
                                </CustomContainer>
                            </GridContainer>
                            <LoginImg className='icon-component'/>
                            <GridContainer 
                                bottomMargin='6' topMargin='1.5'
                            >
                                <AppText color='#ffffff' textSize='5' fontWeight="600">
                                    Welcome to Qstore
                                </AppText>
                                <AppSpan color='#F7F8F9' textSize='1.8'>
                                    Africa’s Foremost Banking-as-a-Platform
                                </AppSpan>
                            </GridContainer>
                        </FlexColumn>
                    </FlexColumn>
                    <FlexColumn
                        width='50' sizeUnit='%' 
                        minHeight='100' mnHUnit='%'
                        bgColor='#ffffff' padding='2'
                        className='login-form-section'
                    >
                        <FixedContainer 
                            top='2.5' left='2' zIndex='2'
                            className='login-logo'
                        >
                            <Logo className='icon-component' />
                        </FixedContainer>

                        <AbsoluteContainer 
                            top='5' right='6'
                            className='login-as-wrapper'
                        >
                            <Dropdown 
                                trigger={
                                    <FlexRow 
                                        justifyContent="space-between" 
                                        width="auto" sizeUnit='' 
                                        height="4" gap="1.5"
                                        radius="0.8" //borderColor="#D0D5DD"
                                        padding="1.5"
                                        className='login-as-container'
                                    >
                                        <AppSpan 
                                            cursor="pointer" color='#0A756F'
                                            fontWeight='500'
                                        >
                                            {`Login as ${utility.toTitleCase(utility.getUserTypeLabel(input?.userType))}`}
                                        </AppSpan>
                                        <FiChevronDown color='#0A756F' fontSize='1.8rem' />
                                    </FlexRow>
                                }
                                options={[
                                    {value: UserType.ADMIN, label: 'Admin'},
                                    {value: UserType.PARTNER, label: 'Partner', disabled: true},
                                    // {value: UserType.CLIENT, label: 'Client'}
                                ]}
                                onSelect={(value: string) => setInput({...input, userType: value})}
                                selectedValue={input.userType}
                                width={15}
                            />
                        </AbsoluteContainer>

                        <CustomContainer 
                            width='40' leftMargin='auto' 
                            rightMargin='auto' sizeUnit=''
                            className='login-form-container'
                        >
                            <AppText 
                                textSize='2.43' color='#3A3A3A' 
                                fontWeight="500" bottomMargin='0.5'
                            >
                                Sign into your Account
                            </AppText>
                            <AppSpan color='#8692A6'>
                                Please enter your institution Code, Username & Password
                            </AppSpan>
                            <Form topMargin='3' onSubmit={handleSubmit}>
                                { [UserType.CLIENT, UserType.PARTNER].includes(input.userType) &&
                                    <FormGroupWithIcon>
                                        <label>{input.userType === UserType.CLIENT ? 'Institution' : 'Service Provider'} code</label>
                                        <div className="input-with-icon">
                                        <input 
                                            placeholder="Enter Code" 
                                            name='institutionCode'
                                            value={input.institutionCode}
                                            onChange={handleInput}
                                            autoComplete='off'
                                            required
                                        />
                                            <ServiceIcon className="icon-component input-with-icon-tag" />
                                        </div>
                                    </FormGroupWithIcon>
                                }
                                <FormGroup>
                                    <label>Username</label>
                                    <input 
                                        placeholder="Enter Username" 
                                        name='username'
                                        value={input.username}
                                        onChange={handleInput}
                                        autoComplete='off'
                                        required
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <label>Password</label>
                                    <input 
                                        placeholder="Enter Password" 
                                        name='password'
                                        type='password'
                                        value={input.password}
                                        onChange={handleInput}
                                        autoComplete='off'
                                        required
                                    />
                                </FormGroup>
                                <Button
                                    width='100' sizeUnit='%'
                                    fontWeight="500" topMargin='2'
                                    height='4.4' radius='0.8'
                                    hoverColor='#0D968F'
                                    hoverBgColor='#ffffff' borderColor='#0D968F'
                                >
                                    Login
                                </Button>
                            </Form>
                            <AppText align='center' topMargin='3.5'>
                                <AppLink 
                                    decoration='none' color='#0A756F' 
                                    fontWeight="500" hoverColor='#1E1E1E'
                                >
                                    Forgot Password
                                </AppLink>
                            </AppText>
                        </CustomContainer>
                    </FlexColumn>
                </FlexRow>
            </CustomContainer>
        </>
    )
}
